import styles from './Button.module.scss';
import { Link } from 'react-router-dom';
import cn from 'clsx';

const Button = ({
  children,
  design = 'dark',
  count,
  size,
  className,
  href,
  ...props
}) => {
  const classes = cn(styles.button, styles[design], styles[size], className);

  if (href) {
    return (
      <Link href={href} className={classes} {...props}>
        {children}
        {count > 0 && <div className={styles.count}>{count}</div>}
      </Link>
    );
  }
  return (
    <button className={classes} {...props}>
      {children}
      {count > 0 && <div className={styles.count}>{count}</div>}
    </button>
  );
};

export default Button;
